import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
const SECRET_KEY = 'rfr_system';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class StorageService {
  constructor(public storage: Storage) { 
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    await this.storage.create();
  }

  public set(settingName : any, value : any) {
    return this.storage.set(`setting:${ settingName }`, value);
  }

  public async get(settingName : any) {
    return await this.storage.get(`setting:${ settingName }`);
  }

  public async remove(settingName : any) {
    return await this.storage.remove(`setting:${ settingName }`);
  }
  
  public clear() {
    this.storage.clear().then(() => {
      // console.log('all keys cleared');
    });
  }

  encryptData(data: any): any {
    try {
        // console.log(data);
        return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    } catch (e) {
        // console.log(e);
        
    }

    return '';
  }

  decryptData(data: any): any {
      try {
          // console.log(data);
          const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY).toString(CryptoJS.enc.Utf8);
          // console.log(bytes);
          if (bytes) {
              return JSON.parse(bytes);
          }
          return data;
      } catch (e) {
          // console.log(e);
      }

      return null;
  }
}
